var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.75,
    cy: 5.25,
    r: 3,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.25 15.75V14.25C2.25 12.5931 3.59315 11.25 5.25 11.25H8.25C9.90685 11.25 11.25 12.5931 11.25 14.25V15.75",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12 7.65C11.6686 7.65 11.4 7.91863 11.4 8.25C11.4 8.58137 11.6686 8.85 12 8.85V7.65ZM16.5 8.85C16.8314 8.85 17.1 8.58137 17.1 8.25C17.1 7.91863 16.8314 7.65 16.5 7.65V8.85ZM14.85 6C14.85 5.66863 14.5814 5.4 14.25 5.4C13.9186 5.4 13.65 5.66863 13.65 6H14.85ZM13.65 10.5C13.65 10.8314 13.9186 11.1 14.25 11.1C14.5814 11.1 14.85 10.8314 14.85 10.5H13.65ZM12 8.85H16.5V7.65H12V8.85ZM13.65 6V10.5H14.85V6H13.65Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatients);
export default __webpack_public_path__ + "static/media/addPatients.41c6be646d8426d97346ef7a9c183af5.svg";
export { ForwardRef as ReactComponent };